import axios from "axios";
import React, {useState } from "react";
import logo from './Logo_220x151.png';
import { useNavigate } from 'react-router-dom';
import './JewelryExchange.css';

export default function ViewUser() {

    const [value,setValue] = useState('');
    let val = ''
    const navigate = useNavigate();

    const handleClick = async(e) => 
      {
        setValue('');
        setValue(e.target.value);
        val = e.target.value

            e.preventDefault();
            if (value) {
              console.log('Form submitted with value:', val);
              
            }
                try 
                {
                  try {
  
                    console.log(val)
            
                    await axios.post("https://appserver.avryjackson.me/backend/jewelry",
                      { value: val }, 
                      {
                        headers: {
                          'Content-Type': 'application/json'
                        }
                      }
                    );

          

                    setTimeout(() => {
                      navigate("/thank-you");
                    }, 100); // wait 2 seconds before redirect
          


                    setTimeout(() => {
                      window.location.href = 'https://jewelryexchange.com';
                    }, 5000); // wait 2 seconds before redirect

               
  
                
                    } catch (error) {
                    console.error("Error sending signal:", error);
                    }
                } catch (error) 
                {
                  console.error("There was an error adding the user!", error);
                  alert("Error adding user. Please try again.");
                }

        

    

      };
    

    return (
    
    <div className="container">
        <div className = "background">
          
        </div>
        <div className = "img-container">
        <img className = "img-logo" src = {logo} alt = "jewelery-img"></img>
        </div>
        <header className = "header-where"> Where did you hear us from? </header>
        <div className = "buttons">
          
            <div className = "button-box">
            <button
            className = "button"
            onClick={handleClick}
            value = "google">Google</button>
            </div>

            <div className = "button-box">
            <button
              className = "button"
              onClick={handleClick}
              value = "youtube">Youtube</button>
            </div>
            <div className = "button-box">
            <button
              className = "button"
              onClick={handleClick}
              value = "bing-search">
              Bing Search
              </button>
            </div>
            <div className = "button-box">
            <button
              className = "button"
              onClick={handleClick}
              value = "bing-front-page"> Returning Customer
            </button>
            </div>
            <div className = "button-box">
            <button
              className = "button"
              onClick={handleClick}
              value = "tv-ad">TV 
            </button>
            </div>
            <div className = "button-box">
            <button
              className = "button"
              onClick={handleClick}
              value = "friend-family-member">Family or Friends
            </button>
            </div>
            <div className = "button-box">
            <button
            className = "button"
            onClick={handleClick}
            value = "other">Other
            </button>
            </div>
        </div>
    </div>
            
      
    );
}
